import React from "react";
import PropTypes from "prop-types";
import StackedBarChart from "../../StackedBarChart/StackedBarChart";

function PointsDistributionChart({ stats }) {
  const { winner, forced, error } = stats;
  return (
    <StackedBarChart
      title="Distribuzione Colpi per Tipo"
      labels={["Dritto", "Rovescio", "Volée", "Smash"]}
      datasets={[
        {
          label: "Vincente",
          data: [winner.forehand, winner.backhand, winner.volley, winner.smash],
          backgroundColor: "#5cb85c",
          stack: "colpo",
        },
        {
          label: "Forzato",
          data: [error.forehand, error.backhand, error.volley, error.smash],
          backgroundColor: "#f0ad4e",
          stack: "colpo",
        },
        {
          label: "Gratuito",
          data: [forced.forehand, forced.backhand, forced.volley, forced.smash],
          backgroundColor: "#d9534f",
          stack: "colpo",
        },
      ]}
    />
  );
}

PointsDistributionChart.propTypes = {};

export default PointsDistributionChart;
